import ConfirmForm from './ConfirmForm'

export default ConfirmForm



// WEBPACK FOOTER //
// ./src/views/Confirm/components/ConfirmForm/index.js